import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Table as TableComponent } from '@src/shared/ui/components/TableStatic';
import { dayjs } from '@uhg-abyss/web/tools/dayjs';
import React, { useMemo } from 'react';

import configuration from './includes/configuration.json';

/**
 * Table
 *
 * Data containing remediating events.
 *
 * @param rows
 * @returns {Element}
 * @constructor
 */
export function Table({ rows }) {
  /**
   * renderCellDate
   *
   * display date in MM/DD/YYYY, HH:mm:ss format.
   *
   * @param cell
   * @returns {*}
   */
  const renderCellDate = ({ cell }) => {
    return dayjs(cell?.value).format('MM/DD/YYYY, HH:mm:ss');
  };

  /**
   * renderCellActiveActionPath
   *
   * display active action path in uppercase.
   *
   * @param cell
   * @returns {string}
   */
  const renderCellActiveActionPath = ({ cell }) => {
    return String(cell?.value).toUpperCase();
  };

  /**
   * renderCellRemediationMethods
   *
   * display remediation methods in uppercase.
   *
   * @param cell
   * @returns {string}
   */
  const renderCellRemediationMethods = ({ cell }) => {
    return String(cell?.value.join(', ')).toUpperCase();
  };

  /**
   * Columns for table.
   */
  const columns = useMemo(() => {
    return configuration?.initialColumns.map((item) => {
      const column = item;

      if (column.Header === 'Date') {
        column.Cell = renderCellDate;
      }

      if (column.Header === 'Active Action Path') {
        column.Cell = renderCellActiveActionPath;
      }

      if (column.Header === 'Remediation Methods') {
        column.Cell = renderCellRemediationMethods;
      }

      return column;
    });
  }, []);

  return (
    <ErrorHandler location="src/widgets/RiskRecords/RemediationEvents/components/Table/Table.jsx">
      <TableComponent
        {...{
          accessor: `eidSearch-remediationEvents`,
          columns,
          configuration,
          rows,
        }}
      />
    </ErrorHandler>
  );
}
